import React, {  } from 'react'
import { Divider } from '@mui/material'
import ApplicationInfo from 'components/ApplicationInfo'
import ApplicantInfo from 'components/ApplicantInfo'

import { makeStyles } from '@mui/styles'
import HelpDialogButton from 'components/ResumeTable/HelpDialogButton'
import { reviewStyles } from './styles'

export default function ComplementaryReviewInfo({ check, review }) {
  const classes = makeStyles(() => (reviewStyles))()
  return (
    <React.Fragment>
      <div className={classes.gappedItem}>
        <h3>Informações Complementares</h3>

        <ApplicantInfo
          applicantData={check?.person}
          creationDate={review?.created}
        />

        <ApplicationInfo check={check} review={review}/>

        <HelpDialogButton />
      </div>
      <Divider flexItem />
    </React.Fragment>
  )
}
